import { ContestTypeEnum } from "predictagram-lib";

export const contestTypeNames: Map<ContestTypeEnum, string> = new Map([
  [ContestTypeEnum.PRIVATE, 'Private'],
  [ContestTypeEnum.PUBLIC, 'Public']
]);